import React, {useState} from 'react'
import {Button, message} from 'antd'
import parseToken from "../../../../helpers/parseToken";
import {formatDate3} from "../../../../helpers/formatDate";
import {exportHubPhoneNumber} from "../../../../services/api/apiReport2";

const Export = (props) => {
    const {filters, tenants, level} = props
    const [loadingE, setLoadingE] = useState(false)

    const _exportReport = async () => {
        setLoadingE(true)
        try {
            const decodeToken = parseToken()
            let _tenantName = ''
            if (tenants.length > 0 && filters?.tenantId) {
                const itemTenant = tenants.find(item => item.value + '' === filters.tenantId)
                if (itemTenant !== undefined) {
                    _tenantName = itemTenant.label
                }
            }
            const payload = {
                ...filters,
                level,
                fromDate: formatDate3(filters.fromDate) + ' 00:00:00',
                toDate: formatDate3(filters.toDate) + ' 23:59:00',
                tenantName: _tenantName,
                userName: decodeToken.sub,
                pagesize: null,
                page: null
            }
            delete payload['page']
            delete payload['limit']
            const response = await exportHubPhoneNumber(payload);
            const {data} = response
            const href = URL.createObjectURL(data);

            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'export.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
            setLoadingE(false)
        } catch (e) {
            message.error(e.message)
            setLoadingE(false)
        }
    }

    return <>
        <Button key="submit" type="primary" loading={loadingE} onClick={_exportReport}>
            Export
        </Button>
    </>
}

export default Export
